import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('updateFieldForm');

    return {
        SAVE: t('save')
    };
};

export default useTranslation;
